import React, { useState } from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import ReactCountryFlag from 'react-country-flag';
import useElementSize from '../../hooks/useElementSize';

function ContactFormSelectFlags({ selectedCountry, countries, setSelectedCountry }) {
  const [ref, width] = useElementSize();

  const flagStyles = {
    width: '22px',
    height: '16.5px',
    outline: '1px solid #000000',
    objectFit: 'cover',
  };

  const menu = (
    <Menu
      className="!shadow-2xl rounded-sm !max-h-[16rem] overflow-y-auto !py-1.5"
      style={{ width: `${width}px` }}
    >
      {countries.map((item, index) => (
        <MenuItem
          key={index}
          className="w-full flex justify-center items-center !h-[28px]"
          onClick={() => setSelectedCountry(item)}
        >
          <ReactCountryFlag countryCode={item.iso} svg style={flagStyles} title={item.iso} />
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div ref={ref} className="w-[60px] !h-[44px] relative border border-r-0 border-greyCloud">
      <Dropdown trigger={['click']} overlay={menu} animation="slide-up">
        <div className="w-full h-full flex items-center justify-center gap-x-2">
          <ReactCountryFlag
            countryCode={selectedCountry.iso}
            svg
            style={flagStyles}
            title={selectedCountry.iso}
          />
          <i className="h-1.5 w-1.5 border-b-[1.5px] border-r-[1.5px] border-black rotate-45" />
        </div>
      </Dropdown>
    </div>
  );
}

export default ContactFormSelectFlags;
